// import io from "socket.io-client";
// import { environment } from "../environments/environments";

// const SOCKET_URL = "https://chat.connecttovow.com";
// // const SOCKET_URL = environment.chatBaseUrl;

// class WSService {
//   initializeSocket = async () => {
//     try {
//       console.log("🔹 SOCKET_URL:", SOCKET_URL);
//       this.socket = io(SOCKET_URL, {
//         transports: ["websocket"],
//       });
//       this.socket.on("connect", () => {
//         console.log("=== socket connected ====");
//       });

//       this.socket.on("disconnect", () => {
//         console.log("=== socket disconnected ====");
//       });

//       this.socket.on("error", (data) => {
//         console.log("socekt error", data);
//       });
//     } catch (error) {
//       console.log("scoket is not inialized", error);
//     }
//   };

//   emit(event, data = {}) {
//     this.socket.emit(event, data);
//   }

//   on(event, cb) {
//     this.socket.on(event, cb);
//   }

//   removeListener(listenerName) {
//     this.socket.removeListener(listenerName);
//   }
// }

// const socketServices = new WSService();

// export default socketServices;

import io from "socket.io-client";
// import { environment } from "../environments/environments";

const SOCKET_URL = "https://chat.connecttovow.com";

class WSService {
  initializeSocket = async () => {
    try {
      console.log("🔹 SOCKET_URL:", SOCKET_URL);
      this.socket = io(SOCKET_URL, {
        transports: ["websocket"],
      });
      this.socket.on("connect", () => {
        console.log("=== socket connected ====");
      });

      this.socket.on("disconnect", () => {
        console.log("=== socket disconnected ====");
      });

      this.socket.on("error", (data) => {
        console.log("socekt error", data);
      });
    } catch (error) {
      console.log("scoket is not inialized", error);
    }
  };

  emit(event, data = {}) {
    this.socket.emit(event, data);
  }

  on(event, cb) {
    this.socket.on(event, cb);
  }

  removeListener(listenerName) {
    this.socket.removeListener(listenerName);
  }
}

const socketServices = new WSService();

export default socketServices;
